export function Section({
  title,
  className,
  children,
}: React.PropsWithChildren<{ title: string; className?: string }>) {
  return (
    <section className="py-6">
      <h6 className="mb-2 text-subtitle1">{title}</h6>
      <div className={className}>{children}</div>
    </section>
  );
}
